import(/* webpackMode: "eager" */ "/home/runner/work/vildarborn/vildarborn/app/[locale]/error.tsx")